<template>
  <v-form @submit.prevent="save" novalidate>
    <pr-box :title="titleBox">

      <div slot="buttons-header">
        <v-btn icon @click.native="goToList">
          <v-icon color="white">list</v-icon>
        </v-btn>
      </div>
      <v-layout row wrap>

        <v-flex xs12 md4>
          <v-text-field
            label="Email"
            v-model="resource.email"
            required
            :error-messages="validationErrors.email">
          </v-text-field>
        </v-flex>

        <v-flex xs12 md4>
          <v-text-field
            label="Workspace"
            v-model="resource.db_name"
            required
            :error-messages="validationErrors.db_name">
          </v-text-field>
        </v-flex>

        <v-flex xs12 md4>
          <v-text-field
            label="Tabela"
            v-model="resource.table_name"
            required
            :error-messages="validationErrors.table_name">
          </v-text-field>
        </v-flex>

      </v-layout>

      <div slot="buttons-footer">
        <v-btn flat type="submit" color="primary" :loading="saveLoading">Salvar</v-btn>
      </div>
    </pr-box>
  </v-form>
</template>

<script>
import CrudMixin from '@/components/mixins/CrudMixin';
import ZohoReportService from '@/features/zoho-report/ZohoReportService';

export default {
  name: 'zoho-report-group-form',
  mixins: [CrudMixin],
  methods: {
    initCrud() {
      this.serviceType = ZohoReportService;
      this.routerName = 'zoho-report-group';
      this.componentType = 'FORM';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/features/zoho-report/ZohoReportGroupForm.vue